import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { V_DEV_LIST } from './DeviceList';
import { TableUseStyle } from './DeviceListStyle';
import DeviceListStatErrorListDialog from './DeviceListStatErrorListDialog';

type DeviceListStatErrorButtonProps = {
  devList: V_DEV_LIST;
};

const DeviceListStatErrorButton: React.FC<DeviceListStatErrorButtonProps> = (props) => {
  const { t } = useTranslation();
  const classes = TableUseStyle();
  const [openErrorList, setOpenErrorList] = useState<boolean>(false);

  /**
   * 状態を取得
   * @param sate
   * @returns
   */
  const getState = (sate?: number): string => {
    if (sate == undefined) return t('DeviceListStatErrorButton.不明', '不明');

    switch (sate) {
      case 0:
        return t('DeviceListStatErrorButton.正常', '正常');
      case 1:
        return t('DeviceListStatErrorButton.軽故障', '軽故障');
      case 2:
        return t('DeviceListStatErrorButton.重故障', '重故障');
      case 4:
        return t('DeviceListStatErrorButton.停止中', '停止中');
      default:
        return t('DeviceListStatErrorButton.不明', '不明');
    }
  };

  /**
   * 状態の色を取得
   * @param sate
   * @returns
   */
  const getSENSOR_COLMNGSStatusColor = (sate?: number): string => {
    if (sate == undefined) return 'silver';

    switch (sate) {
      case 0: //正常
        return 'green';
      case 1: //軽故障
        return '#FFF380';
      case 2: //重故障
        return 'red';
      case 4: //停止中
        return 'silver';
      default:
        //不明
        return 'silver';
    }
  };

  /**
   * エラーログ日時選択ダイアログOPEN
   */
  const errorListDialogOpenAction = () => {
    setOpenErrorList(true);
  };

  /**
   * エラーログ日時選択閉じる
   */
  const errorListDialogCloseAction = () => {
    setOpenErrorList(false);
  };

  /**
   * ラベル時の文字色取得
   * @param sate
   * @returns
   */
  const getLabelTextColor = (sate?: number): string => {
    let displayColor = sate == 1 ? 'black' : 'white';
    return displayColor;
  };
  /**
   * ボタンの文字色取得
   * @param sate
   * @returns
   */
  const getButtonTextColor = (sate?: number): string => {
    if (sate == undefined) return 'silver';

    switch (sate) {
      case 0: //正常
        return 'green';
      case 1: //軽故障
        return '#FFF380';
      case 2: //重故障
        return 'red';
      case 4: //停止中
        return 'silver';
      default:
        //不明
        return 'silver';
    }
  };

  return (
    <>
      {/**軽故障・重故障の場合はボタンに変更、それ以外はラベル表示 */}
      {props.devList.STAT !== 1 && props.devList.STAT !== 2 ? (
        <div
          style={{
            background: getSENSOR_COLMNGSStatusColor(props.devList.STAT),
            color: getLabelTextColor(props.devList.STAT),
            padding: '5px',
          }}
        >
          {getState(props.devList.STAT)}
        </div>
      ) : (
        <Button
          className={classes.buttonStyle}
          style={{
            borderColor: getSENSOR_COLMNGSStatusColor(props.devList.STAT),
            color: getButtonTextColor(props.devList.STAT),
            width: '130px',
          }}
          variant="outlined"
          onClick={(e) => errorListDialogOpenAction()}
        >
          {getState(props.devList.STAT)}
        </Button>
      )}
      <DeviceListStatErrorListDialog
        open={openErrorList}
        onClose={errorListDialogCloseAction}
        devListData={props.devList}
      ></DeviceListStatErrorListDialog>
    </>
  );
};
export default DeviceListStatErrorButton;
